import { useEffect, useState } from 'react';
import type { ThemeId } from '@otter/shared';
import { api } from '../../lib/api';
import { applyTheme, THEMES } from '../../lib/theme';

type Props = {
  onToast: (msg: string, kind?: 'ok' | 'err') => void;
  onError: (e: unknown) => void;
};

export function Apariencia({ onToast, onError }: Props) {
  const [current, setCurrent] = useState<ThemeId>('dark-lima');

  useEffect(() => {
    void api<{ userSettings: { theme: ThemeId } }>('/admin/settings')
      .then((r) => setCurrent(r.userSettings.theme))
      .catch(onError);
  }, [onError]);

  async function pick(id: ThemeId) {
    setCurrent(id);
    applyTheme(id);
    try {
      await api('/admin/settings/me', { method: 'PATCH', body: { theme: id } });
      onToast('Tema actualizado', 'ok');
    } catch (e) {
      onError(e);
    }
  }

  return (
    <div className="adm-section">
      <div className="stitle">Apariencia · tema</div>
      <h2>Elige tu tema</h2>
      <div className="theme-grid">
        {THEMES.map((t) => (
          <div
            key={t.id}
            className={`theme-card ${current === t.id ? 'on' : ''}`}
            onClick={() => pick(t.id)}
          >
            <div className="swatch" style={{ background: t.swatch[0] }}>
              <div className="lump" style={{ background: t.swatch[1] }} />
              <div className="lump" style={{ background: t.swatch[2] }} />
              <div className="lump" style={{ background: t.swatch[3] }} />
            </div>
            <div className="ttl">
              <b>{t.label}</b>
              <span>{t.mode}</span>
            </div>
            <div className="desc">{t.desc}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
